import React from 'react'
import '../myHrManage.scss'

const InfoCard = ({ title, data, gridColumns = 'repeat(2, 1fr)' }) => {
  // gridColumns에서 숫자 추출 (예: 'repeat(2, 1fr)' -> 2, 'repeat(3, 1fr)' -> 3)
  const columnsMatch = gridColumns.match(/repeat\((\d+)/)
  const columnCount = columnsMatch ? parseInt(columnsMatch[1], 10) : 2

  return (
    <div className="info-card">
      {title && <div className="info-card-title">{title}</div>}
      <div
        className="info-card-grid"
        style={{ gridTemplateColumns: gridColumns }}
      >
        {data.map((item, index) => {
          // 마지막 행인지 확인
          const isLastRow =
            Math.floor(index / columnCount) ===
            Math.floor((data.length - 1) / columnCount)
          // 마지막 열인지 확인
          const isLastColumn = (index + 1) % columnCount === 0

          return (
            <div
              key={index}
              className={`info-card-item ${
                isLastRow ? 'info-card-item-no-bottom-border' : ''
              } ${isLastColumn ? 'info-card-item-no-right-border' : ''}`}
            >
              <span className="info-card-label">{item.label}</span>
              <span className="info-card-value">{item.value || '-'}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default InfoCard
